import request from '@/utils/request'

let LotteryApi = {

    /*抽奖码列表*/
    lotterylist(data, errorback) {
        return request._post('/shop/plus.lottery.lottery/index', data, errorback);
    },

    /*添加抽奖码*/
    addlottery(data, errorback) {
        return request._post('/shop/plus.lottery.lottery/add', data, errorback);
    },

    /*修改抽奖码*/
    detaillottery(data, errorback) {
        return request._post('/shop/plus.lottery.lottery/detail', data, errorback);
    },
    /*奖品详情*/
    getLotteryData(data, errorback) {
        return request._get('/shop/plus.lottery.lottery/getLotteryData', data, errorback);
    },
    /*删除抽奖码*/
    deleteuser(data, errorback) {
        return request._post('/shop/plus.lottery.lottery/delete', data, errorback);
    },


    /*导出抽奖码*/
    exportLottery(data, errorback) {
        return request._post('/shop/plus.lottery.lottery/export', data, errorback);
    },

    /*奖品列表*/
    // lotterylist(data, errorback) {
    //     return request._post('/shop/plus.lottery.prize/index', data, errorback);
    // },

    /*获取抽奖设置*/
    settingDetail(data, errorback) {
        return request._get('/shop/plus.lottery.setting/index', data, errorback);
    },
    /*提交修改抽奖设置*/
    editSetting(data, errorback) {
        return request._get('/shop/plus.lottery.setting/editSetting', data, errorback);
    },

    /*奖品列表*/
    prizeList(data, errorback) {
        return request._get('/shop/plus.lottery.prize/index', data, errorback);
    },
    /*奖品添加*/
    prizeAdd(data, errorback) {
        return request._post('/shop/plus.lottery.prize/add', data, errorback);
    },

    /*奖品编辑*/
    prizeEdit(data, errorback) {
        return request._post('/shop/plus.lottery.prize/edit', data, errorback);
    },
    /*奖品详情*/
    getPrizeData(data, errorback) {
        return request._get('/shop/plus.lottery.prize/getPrizeData', data, errorback);
    },
    /*删除奖品*/
    deletePrice(data, errorback) {
        return request._post('/shop/plus.lottery.prize/delete', data, errorback);
    },
    /*更改奖品状态*/
    updateStatus(data, errorback) {
        return request._post('/shop/plus.lottery.prize/updateStatus', data, errorback);
    },
    /*抽奖记录列表*/
    drawList(data, errorback) {
        return request._get('/shop/plus.lottery.draw/index', data, errorback);
    },
    /*领取记录列表*/
    acceptList(data, errorback) {
        return request._get('/shop/plus.lottery.accept/index', data, errorback);
    },

    /*中奖记录列表*/
    winList(data, errorback) {
        return request._get('/shop/plus.lottery.win/index', data, errorback);
    },
    /*抽奖参与用户列表*/
    getDrawUserData(data,errorback){
        return request._get('/shop/plus.lottery.draw/getDrawUserData', data, errorback);
    },
    /*中奖详情*/
    winlotterydetail(data, errorback) {
        return request._post('/shop/plus.lottery.accept/detail', data, errorback);
    },
    /*奖品发货*/
    delivery(data, errorback) {
        return request._post('/shop/plus.lottery.accept/delivery', data, errorback);
    },
    /*导出抽奖码*/
    exportLotteryUsers(data, errorback) {
        return request._post('/shop/plus.lottery.draw/exportList', data, errorback);
    },
}

export default LotteryApi;



// WEBPACK FOOTER //
// ./src/api/lottery.js